<div class="container">

  <div class="card">

    <!-- Dropdown -->
    <div class="form-group">
      <label>نوع اللجنة</label>
      <select [(ngModel)]="selectedCommittee">
        <option value="">-- اختر --</option>
        <option *ngFor="let item of dropdownList" [value]="item.key">
          {{ item.value }}
        </option>
      </select>

      <div class="error" *ngIf="submitted && !selectedCommittee">
        مطلوب اختيار نوع اللجنة
      </div>
    </div>

    <!-- Date -->
    <div class="form-group">
      <label>التاريخ</label>
      <input type="date" [(ngModel)]="selectedDate" />

      <div class="error" *ngIf="submitted && !selectedDate">
        التاريخ مطلوب
      </div>
    </div>

    <!-- Time -->
<div class="form-group">
  <label>الوقت (اختياري)</label>

 <div class="time-wrapper">
  <input type="time" [(ngModel)]="selectedTime" />

  <button type="button" class="clear-btn" (click)="selectedTime = null">
    مسح
  </button>
</div>
</div>

    <!-- Button -->
    <button (click)="search()" [disabled]="loading">
      {{ loading ? 'جاري البحث...' : 'بحث' }}
    </button>

  </div>

  <!-- Results -->
 <div class="results" *ngIf="exams.length > 0">

  <div class="exam-card" *ngFor="let exam of exams">
    
    <div class="name">{{ exam.appplicantName }}</div>

    <!-- Row 1 -->
   <!-- Row 1 -->
<div class="row">
  <div class="item">
    <span>الرقم:</span>
    {{ exam.nationalId }}
  </div>

  <div class="item">
    <span>التاريخ:</span>
    {{ exam.examinationDate | date:'yyyy-MM-dd' }}
  </div>
</div>

<!-- Row 2 -->
<div class="row">
  <div class="item">
    <span>الطلب:</span>
    {{ exam.applicationNumber }}
  </div>

  <div class="item">
    <span>الوقت:</span>
   {{ exam.examinationTime || '-' }}
  </div>
</div>

<!-- Row  -->
<div class="row">
  <div class="item">
  <span>الهاتف:</span>
  <span class="phone">{{ exam.phoneNumber1 }}</span>
</div>
  

  <!-- show only if exists -->
 <div class="item" *ngIf="exam.phoneNumber2">
  <span>هاتف 2:</span>
  <span class="phone">{{ exam.phoneNumber2 }}</span>
</div>
</div>

  </div>

</div>

  <div class="empty" *ngIf="!loading && exams.length === 0 && submitted">
    لا توجد نتائج
  </div>

</div>